import { css } from "./css";
import { setProps, Template } from "./setProps";

type Props = {
  isArabic: boolean;
};

export const setTextRightArabic = (): ((props: Props) => string | Template) => {
  return setProps<Props>(({ isArabic }) => isArabic)(css`
    text-align: right;
  `);
};
